const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

// `new Date('YYYY-MM-DD')` is UTC midnight (KST 09:00), which expired
// coupons on the morning of their last day.
export const couponValidUntilIso = (dateStr) => {
  if (!dateStr) return null;
  if (!DATE_ONLY_PATTERN.test(dateStr)) return new Date(dateStr).toISOString();
  return new Date(`${dateStr}T23:59:59.999+09:00`).toISOString();
};

export const couponDateInputValue = (isoStr) => {
  if (!isoStr) return '';
  const date = new Date(isoStr);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-CA', { timeZone: 'Asia/Seoul' });
};
